import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FullpageOverlayComponent } from './fullpage-overlay.component';

@NgModule({
	declarations: [FullpageOverlayComponent],
	imports: [CommonModule],
	exports: [FullpageOverlayComponent],
})
export class FullpageOverlayModule {}
